import React from 'react';
import clsx from 'clsx';
import DOMPurify from 'dompurify';

/**
 * This component renders a textarea with a monospaced font. It sanitizes the input
 * on blur before passing it to a submit handler.
 *
 * @param {object} props - The component props.
 * @param {string} [props.inputClasses] - Additional CSS classes for the textarea input.
 * @param {string} [props.wrapperClasses] - Additional CSS classes for the component wrapper div.
 * @param {string} [props.labelClasses] - Additional CSS classes for the legend.
 * @param {string} props.name - The name of the input, used for id and form submission.
 * @param {string} props.label - The text to display for the legend.
 * @param {string} [props.response] - The initial value of the textarea.
 * @param {string} [props.placeholder='Write your response'] - The placeholder text for the textarea.
 * @param {function(string): void} props.handleSubmit - The function to call on blur with the sanitized textarea value.
 */
export const CodeBlock = ({
  inputClasses,
  wrapperClasses,
  labelClasses,
  name,
  label,
  response,
  placeholder = 'Write your response',
  handleSubmit,
}) => {
  const sanitize = (value) => {
    return DOMPurify.sanitize(value.trim());
  };

  return (
    <div
      key={name}
      className={clsx(wrapperClasses, 'custom-form-field--code-block')}
    >
      <legend
        className={labelClasses}
        htmlFor={`custom-form-field-${name}`}
      >
        {label}
      </legend>
      <textarea
        id={`custom-form-field-${name}`}
        name={name}
        defaultValue={response}
        placeholder={placeholder}
        rows={6}
        onBlur={(e) => handleSubmit(sanitize(e.target.value))}
        className={inputClasses}
        style={{ fontFamily: 'Monaco, Consolas, "Courier New", monospace' }}
      />
    </div>
  );
};
